import { GetServerSideProps } from 'next';

import AmexContextProvider from '@/components/amex/AmexContextProvider';
import Landing from '@/components/amex/Landing';
import Layout from '@/components/layout/LayoutWrapper';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const AmericanExpressGlobal = () => {
	return (
		<Layout pageName="amexglobal">
			<AmexContextProvider isAmexGlobal>
				<Landing />
			</AmexContextProvider>
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		{
			promotion: 'amex_card_member',
		},
	);

	return {
		props: {
			initialState,
		},
	};
};

export default AmericanExpressGlobal;
